module.exports = __webpack_public_path__ + "img/m-solution.cf7194bd.jpg";